import { css } from 'styled-components';
import { getOverrideBackground } from '../../../utils/utilityFunction';
import breakPoints from '../../../themes/breakpoints';
var background;
var styles = css([".mobile-variation-full &{position:absolute;top:0;left:0;height:100%;width:100%;&.light{background-color:rgba(255,255,255,0.1);}&.dark{background-color:rgba(0,0,0,0.1);}&.bg-color-override.dark,&.bg-color-override.light{@media (max-width:", "){", ";}}}"], breakPoints.mobile, function (props) {
  if (props.background) {
    var _props$theme, _props$theme$accordio, _props$theme2;
    var overrideBackground = props.background;
    background = getOverrideBackground({
      entry: overrideBackground,
      themeBgColor: (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$accordio = _props$theme.accordion) === null || _props$theme$accordio === void 0 ? void 0 : _props$theme$accordio.bodyBackgroundColor,
      colorPalette: (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.palette
    });
    return background.css;
  }
});
export default styles;